import { DEFAULT_PALETTE } from '../../core/palette';
import type { ParamSchema, SchemaValues } from '../../core/params/types';

export const ROPE_PARAMS = [
  {
    kind: 'float',
    key: 'length',
    label: 'Seillänge',
    min: 20,
    max: 900,
    step: 5,
    scale: 'log',
    default: 240,
    unit: 'px',
    bulkRange: [80, 500],
    group: 'Seil',
  },
  {
    kind: 'float',
    key: 'lengthJitter',
    label: 'Längenstreuung',
    min: 0,
    max: 1,
    step: 0.01,
    default: 0.35,
    group: 'Seil',
  },
  {
    kind: 'int',
    key: 'segments',
    label: 'Segmente',
    min: 3,
    max: 80,
    step: 1,
    default: 18,
    group: 'Seil',
  },
  {
    kind: 'float',
    key: 'stiffness',
    label: 'Steifigkeit',
    min: 0.1,
    max: 1,
    step: 0.01,
    default: 0.9,
    group: 'Seil',
  },
  {
    kind: 'enum',
    key: 'anchor',
    label: 'Aufhängung',
    default: 'top',
    group: 'Seil',
    options: [
      { value: 'top', label: 'Oberer Rand' },
      { value: 'spread', label: 'Verteilt oben' },
      { value: 'centre', label: 'Ein Punkt' },
      { value: 'original', label: 'Über der Originalposition' },
    ],
  },

  {
    kind: 'float',
    key: 'gravity',
    label: 'Schwerkraft',
    min: 0,
    max: 2,
    step: 0.01,
    default: 0.55,
    group: 'Kräfte',
  },
  {
    kind: 'float',
    key: 'wind',
    label: 'Wind',
    min: 0,
    max: 3,
    step: 0.01,
    default: 0.5,
    group: 'Kräfte',
  },
  {
    kind: 'float',
    key: 'windFrequency',
    label: 'Windfrequenz',
    min: 0.05,
    max: 4,
    step: 0.05,
    default: 0.55,
    group: 'Kräfte',
    showIf: (v) => (v.wind as number) > 0,
  },
  {
    kind: 'float',
    key: 'damping',
    label: 'Dämpfung',
    min: 0,
    max: 0.2,
    step: 0.005,
    default: 0.02,
    group: 'Kräfte',
  },
  {
    kind: 'int',
    key: 'steps',
    label: 'Standbild nach',
    min: 1,
    max: 1200,
    step: 1,
    default: 260,
    unit: 'Schr.',
    bulkRange: [60, 600],
    group: 'Kräfte',
  },

  {
    kind: 'float',
    key: 'letterSize',
    label: 'Buchstabengrösse',
    min: 8,
    max: 400,
    step: 1,
    scale: 'log',
    default: 96,
    unit: 'px',
    bulkRange: [40, 200],
    group: 'Darstellung',
  },
  {
    kind: 'bool',
    key: 'followRope',
    label: 'Buchstabe folgt dem Seil',
    default: true,
    group: 'Darstellung',
  },
  {
    kind: 'float',
    key: 'ropeWidth',
    label: 'Seilstärke',
    min: 0.2,
    max: 12,
    step: 0.1,
    default: 1.4,
    unit: 'px',
    group: 'Darstellung',
  },
  {
    kind: 'float',
    key: 'opacity',
    label: 'Deckkraft',
    min: 0.05,
    max: 1,
    step: 0.01,
    default: 1,
    group: 'Darstellung',
  },

  {
    kind: 'palette',
    key: 'palette',
    label: 'Palette',
    default: { ...DEFAULT_PALETTE, paletteId: 'ember' },
    group: 'Farbe',
  },
  {
    kind: 'color',
    key: 'ropeColor',
    label: 'Seilfarbe',
    default: '#6b6b7c',
    group: 'Farbe',
  },
] as const satisfies ParamSchema;

export type RopeValues = SchemaValues<typeof ROPE_PARAMS>;
